module.exports = __webpack_public_path__ + "static/zigzag-image2-bc87028b620f3a91c6f56ba8215fe2ec.png";